import { Component, Input, OnInit } from '@angular/core';
import { BreadCrumbs } from '@usf/product-types';
import { Crumb } from 'src/app/shared/components/breadcrumbs/breadcrumbs.component';
import { PageTitle } from '../../../shared/constants/page-titles.enum';

@Component({
  selector: 'app-search-breadcrumb',
  templateUrl: './search-breadcrumb.component.html',
  styleUrls: ['./search-breadcrumb.component.scss'],
})
export class SearchBreadcrumbComponent implements OnInit {
  @Input()
  pageType: string;

  @Input()
  breadcrumbData?: BreadCrumbs;

  breadcrumbs: Crumb[];

  constructor() {}

  ngOnInit() {
    if (!this.pageType || 'SearchResultsPage' === this.pageType) {
      this.breadcrumbs = [
        {
          label: 'i18n.breadcrumbs.home',
          url: '/desktop/home',
          active: false,
        },
        {
          label: 'i18n.breadcrumbs.searchResults',
          url: '',
          active: true,
        },
      ];
    } else if ('ProductListingPage' === this.pageType) {
    }
  }
}
